import { i18n } from "../shared/language";

const lawBasisKeysBefore2026 = [
  "common.lawBasisDecree123",
  "common.lawBasisDecree70",
  "common.lawBasisCircular32",
  "common.lawBasisAgreement",
];

const lawBasisKeysFrom2026 = [
  "common.lawBasisDecree254",
  "common.lawBasisCircular91",
  "common.lawBasisAgreement",
];

export const getLawBases = (documentDate: Date | string | null | undefined): string[] => {
  const boundaryDate = new Date('2026-07-01');
  const date = documentDate ? new Date(documentDate) : new Date();
  const keys = date < boundaryDate ? lawBasisKeysBefore2026 : lawBasisKeysFrom2026;

  return keys.map((key) => i18n.t(key));
};

export const getLawBasesText = (documentDate: Date | string | null | undefined): string => {
  const list = getLawBases(documentDate);
  return "\n" + list.map(item => `            - ${item}`).join("\n") + "\n            ";
};
